import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import ZoomIn from '@mui/icons-material/ZoomIn';
import ZoomOut from '@mui/icons-material/ZoomOut';

const PreviewZoomComponent = ({ scale, setScale }) => {
  const handleZoomOut = () => {
    if (scale < 0.3) return;
    setScale(update => update - 0.2);
  };
  const handleZoomIn = () => setScale(update => update + 0.2);

  return (
    <>
      <IconButton color='primary' size='small' variant='text' onClick={handleZoomIn} aria-label='zoom-in'>
        <ZoomIn />
      </IconButton>
      <IconButton disabled={scale < 0.3} color='primary' size='small' variant='text' onClick={handleZoomOut} aria-label='zoom-out'>
        <ZoomOut />
      </IconButton>
    </>
  );
};

PreviewZoomComponent.propTypes = {
  scale: PropTypes.number.isRequired,
  setScale: PropTypes.func.isRequired
};

export default PreviewZoomComponent;
